const KOKETA_CART_REMINDER_KEY = 'koketa-cart-reminder-end-v1';
const KOKETA_CART_REMINDER_COOLDOWN = 30 * 60 * 1000;

class KoketaCartCountdown extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.time = this.querySelector('[data-koketa-countdown-time]');
    this.title = this.querySelector('[data-koketa-countdown-title]');
    this.copy = this.querySelector('[data-koketa-countdown-copy]');
    this.help = this.querySelector('[data-koketa-countdown-help]');
    this.status = this.querySelector('[data-koketa-countdown-status]');
    this.completeTitle = this.dataset.completeTitle || 'Need help deciding?';
    this.completeCopy = this.dataset.completeCopy || 'Your cart is still available; we can help you on WhatsApp.';
    this.completeStatus = this.dataset.completeStatus || 'The reminder has ended. Your cart is still available and you can ask for help on WhatsApp.';
    this.duration = Math.max(60, Number.parseInt(this.dataset.duration || '300', 10)) * 1000;
    this.end = this.getEndTime();
    this.timer = null;
    this.completed = false;
    this.tick();
    if (!this.completed) this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    this.dataset.initialized = 'false';
  }

  getEndTime() {
    const now = Date.now();
    try {
      const stored = Number.parseInt(sessionStorage.getItem(KOKETA_CART_REMINDER_KEY) || '0', 10);
      if (stored > now || (stored > 0 && now - stored < KOKETA_CART_REMINDER_COOLDOWN)) return stored;
      const end = now + this.duration;
      sessionStorage.setItem(KOKETA_CART_REMINDER_KEY, String(end));
      return end;
    } catch (_error) {
      return now + this.duration;
    }
  }

  tick() {
    const remaining = Math.max(0, this.end - Date.now());
    if (remaining <= 0) {
      this.complete();
      return;
    }

    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    if (this.time) this.time.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  complete() {
    if (this.completed) return;
    this.completed = true;
    window.clearInterval(this.timer);
    this.timer = null;
    this.classList.add('is-complete');
    if (this.time) this.time.textContent = '00:00';
    if (this.title) this.title.textContent = this.completeTitle;
    if (this.copy) this.copy.textContent = this.completeCopy;
    if (this.help) this.help.hidden = false;
    if (this.status) this.status.textContent = this.completeStatus;
  }
}

if (!customElements.get('koketa-cart-countdown')) customElements.define('koketa-cart-countdown', KoketaCartCountdown);
